import { formatSizeLabel } from './productSize';

export const saleReceiptHtml = (sale) => {
  const rows = (sale.items || [])
    .map(
      (item) => `<tr>
        <td>${item.productName}<div class="muted">${formatSizeLabel(item.size)}${item.color ? ` · ${item.color}` : ''}${item.wholesalePrice != null ? ` · W ₹${item.wholesalePrice}` : ''}</div></td>
        <td class="qty">${item.quantity}</td>
        <td class="num">₹${Number(item.unitPrice).toFixed(0)}</td>
        <td class="num">₹${Number(item.lineTotal).toFixed(0)}</td>
      </tr>`
    )
    .join('');

  return `<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  <title>${sale.invoiceNumber || 'Invoice'}</title>
  <style>
    @page { margin: 12mm; }
    body { font-family: Arial, sans-serif; font-size: 13px; color: #111; padding: 8px; }
    h1 { font-size: 22px; margin: 0 0 4px; text-align: center; color: #56112A; }
    .sub { text-align: center; color: #555; margin-bottom: 16px; }
    table { width: 100%; border-collapse: collapse; }
    th, td { padding: 8px 0; vertical-align: top; border-bottom: 1px solid #eee; }
    th { border-bottom: 1px solid #111; text-align: left; }
    .num, .qty { text-align: right; }
    .muted { color: #666; font-size: 11px; }
    .totals { margin-top: 12px; border-top: 1px dashed #111; padding-top: 10px; }
    .row { display: flex; justify-content: space-between; margin: 4px 0; }
    .total { font-size: 18px; font-weight: 700; color: #56112A; }
  </style>
</head>
<body>
  <h1>theVastra.store</h1>
  <div class="sub">${sale.invoiceNumber || ''}<br/>${(sale.mode || 'custom').toUpperCase()} BILL<br/>${sale.createdAt ? new Date(sale.createdAt).toLocaleString() : ''}</div>
  ${sale.customerName ? `<div>Customer: ${sale.customerName}</div>` : ''}
  <table>
    <thead><tr><th>Item</th><th class="qty">Qty</th><th class="num">Sell price</th><th class="num">Amt</th></tr></thead>
    <tbody>${rows}</tbody>
  </table>
  <div class="totals">
    <div class="row"><span>Subtotal</span><span>₹${Number(sale.subtotal || sale.total || 0).toFixed(0)}</span></div>
    <div class="row"><span>Discount</span><span>₹${Number(sale.discount || 0).toFixed(0)}</span></div>
    <div class="row total"><span>Total</span><span>₹${Number(sale.total || 0).toFixed(0)}</span></div>
    <div class="row"><span>Payment</span><span>${(sale.paymentMethod || 'cash').toUpperCase()}</span></div>
  </div>
  <p class="sub">Thank you for shopping with theVastra.store</p>
</body>
</html>`;
};

export const printSaleReceipt = (sale) => {
  const frame = window.open('', '_blank', 'width=480,height=720');
  if (!frame) return;
  frame.document.write(saleReceiptHtml(sale));
  frame.document.close();
  frame.focus();
  frame.print();
};
